import { Component, ViewChild, ElementRef, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatRadioChange } from "@angular/material/radio";
import { SearchType } from "../../model/searchType";

@Component({
    selector: "it-search-dialog",
    templateUrl: "./search-dialog.component.html",
    styleUrls: ["./search-dialog.component.scss"],
    standalone: false
})
export class SearchDialogComponent {
  public searchText: string;
  public searchTypes: string[] = ["Search Inspections", "Search Items"];
  public selectedSearchType: string = "Search Inspections";

  @ViewChild("searchButton") searchButton: ElementRef;

  constructor(
    private dialogRef: MatDialogRef<SearchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
  ) {}

  ngOnInit(): void {
    if (this.data) {
      this.selectedSearchType = this.data.seletedSearchType;
      this.searchText = this.data.searchText;
    }
  }

  public cancel(): void {
    this.dialogRef.close({
      action: false,
      searchText: this.searchText,
    } as SearchDialogResult);
  }

  public search(): void {
    this.dialogRef.close({
      action: true,
      searchText: this.searchText,
      searchType:
        this.selectedSearchType == "Search Inspections"
          ? SearchType.inspections
          : SearchType.items,
    } as SearchDialogResult);
  }

  public onSelectionChange(event: MatRadioChange): void {
    this.selectedSearchType = event.value;
  }

  public onKeyDown(event): void {
    if (event.key == "Enter") {
      this.search();
    }
  }
}

export class SearchDialogResult {
  action: boolean;
  searchText: string;
  searchType: SearchType;
}
